import s, { forwardRef as x, useState as r, useEffect as E } from "react";
import { SelectionItemsDefaultProps as S } from "../props.js";
import { Check as b } from "@olxbr/ds-icons";
const u = x((d, h) => {
  const {
      selectionItems: l = S.selectionItems,
      onSelectedChange: o
    } = d,
    _ = l == null ? void 0 : l.map(e => e.isSelected),
    [c, f] = r(_),
    [n, p] = r([]);
  E(() => {
    o == null || o(n);
  }, [o, n]);
  const v = e => {
    if (l[e].isDisabled) return;
    const t = c.map((i, m) => m === e ? !i : i);
    f(t), t[e] ? p([...n, l[e].value]) : p(n.filter(i => i !== l[e].value));
  };
  return s.createElement("ul", {
    className: "olx-chips__items"
  }, l == null ? void 0 : l.map((_ref, a) => {
    let {
      label: e,
      value: t,
      icon: i,
      isDisabled: m
    } = _ref;
    return s.createElement("li", {
      className: "olx-chips__item",
      key: "olx-chips_".concat(t)
    }, s.createElement("div", {
      className: "olx-chips__input-wrapper",
      ref: h
    }, s.createElement("input", {
      "data-ds-component": "DS-Chips",
      type: "checkbox",
      className: "olx-chips__input",
      id: "multi-chips-id-".concat(a),
      name: t,
      checked: !!c[a],
      "aria-checked": !!c[a],
      disabled: !!m,
      onChange: () => v(a)
    }), s.createElement("label", {
      htmlFor: "multi-chips-id-".concat(a),
      className: (t == null ? void 0 : t.length) === 1 ? "olx-chips__input--one-value" : ""
    }, c[a] ? s.createElement(b, null) : i, e)));
  }));
});
u.displayName = "MultiSelect";
export { u as MultiSelect };